import { taskStatusOptions } from 'constants/options';
import { TaskStatus } from 'constants/tasks';

import { closeDialogAction } from 'store/global/actions';

// Routes TaskInfo's close/dismiss. When hosted inline (expandable row) the caller passes
// onClose to collapse the row; when hosted in a dialog onClose is undefined and we close the
// modal. Shared by Cancel and every success path (approve / update / submit) so both usages
// dismiss correctly.
export const resolveTaskInfoClose = ({ onClose, dispatch }) => {
  if (onClose) {
    onClose();

    return;
  }

  dispatch(closeDialogAction());
};

// Update Status (unlike Document Approval) may only move a task to Cancelled or Rejected.
const UPDATE_STATUS_ONLY_TASK_STATUSES = [TaskStatus.CANCELED, TaskStatus.REJECTED];

// The current status is always kept in the list so the Autocomplete value resolves to a real
// option (MUI renders a blank field for a value absent from options) — the user still can only
// SELECT Cancelled/Rejected.
export const getTaskStatusOptions = ({
  isApproveRejectCancelAllowed,
  isUpdateStatusAllowed,
  currentStatus,
}) =>
  isApproveRejectCancelAllowed || !isUpdateStatusAllowed
    ? taskStatusOptions
    : taskStatusOptions.filter(
        ({ value }) => UPDATE_STATUS_ONLY_TASK_STATUSES.includes(value) || value === currentStatus,
      );
